import { createApp } from 'vue';
import { router } from '@/router';
import App from "@/App.vue";
import { BootstrapVue3, BToastPlugin } from 'bootstrap-vue-3'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css';
import VueApexCharts from 'vue3-apexcharts';
import DatePicker from 'vue3-datepicker';
import FlagIcon from 'vue-flag-icon';
import VueFeather from 'vue-feather';
import StarRating from "vue-star-rating";
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';
import ThemifyIcon from "vue-themify-icons";
import SimpleLineIcons from "vue-simple-line";
import VueEasyLightbox from "vue-easy-lightbox";
import CKEditor from '@ckeditor/ckeditor5-vue';
import mitt from 'mitt';
import { Modal } from "bootstrap";
import store from '@/store/index';

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@fortawesome/fontawesome-free/css/fontawesome.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import 'sweetalert2/dist/sweetalert2.min.css';
import "boxicons/css/boxicons.min.css";
import 'pe7-icon/dist/dist/pe-icon-7-stroke.css';
import 'typicons.font/src/font/typicons.css';
import 'weathericons/css/weather-icons.css'
import 'ionicons-npm/css/ionicons.css';
import '@/assets/css/feather.css'
import '@/assets/css/tabler-icons.css'
import '@/assets/scss/main.scss';
import '@/assets/css/custom.css';


// *************** Components ***************
import Breadcrumb from "@/components/breadcrumb/page-header.vue"
import DashboardHeader from "@/components/breadcrumb/dashboard-header.vue"

// *************** Layout Component ***************
import Header from "@/views/layouts/layouts-header.vue"
import Sidebar from "@/views/layouts/layouts-sidebar.vue"
import VerticalSidebar from '@/views/layouts/vertical-sidebar.vue'
import FilesSidebar from "@/views/layouts/files-sidebar.vue";
import SideSettings from '@/views/layouts/side-settings.vue'
import IndexLoader from '@/views/layouts/index-loader.vue'

// *************** Page Component ***************
import Leads_Tabs from '@/views/pages/leads/leads-tabs.vue';
import Leads_Details_Tabs from '@/views/pages/leads/leads-details-tabs.vue';
import Individual_Sidebar from '@/views/pages/leads/individual/individual-sidebar.vue'; 
import Organization_Sidebar from '@/views/pages/leads/organization/organization-sidebar.vue';
import Leads_details_Sidebar from '@/views/pages/leads/organization/leads-details-sidebar.vue';
import Organization_Update_Sidebar from '@/views/pages/leads/organization/organization-update-sidebar.vue';
import Leads_Details_Section from '@/components/LeadsDetails/DetailsSection.vue';
import Leads_Concern_person_Details_Modal from '@/components/LeadsDetails/ConcernPersonModal.vue';
import File_Preview_Check from '@/components/LeadsDetails/FilePreviewCheck.vue';

// *************** Basic settings modal Component ***************
import Countires_Modal from '@/components/modal/basic_settings/countires-modal.vue'
import ProfessionListModal from '@/components/modal/basic_settings/profession-list-modal.vue';
import DepartmentsListModal from '@/components/modal/basic_settings/department-list-modal.vue';
import DesignationsListModal from '@/components/modal/basic_settings/designations-list-modal.vue';
import BirthdayListModal from '@/components/modal/birthday-list-modal.vue';
import SourceListModal from '@/components/modal/basic_settings/source-list-modal.vue';
import CampaignListModal from '@/components/modal/basic_settings/campaign-list-modal.vue';
import ExhibitionListModal from '@/components/modal/basic_settings/exhibitions-list-modal.vue';
import IndustryListModal from '@/components/modal/basic_settings/industry-list-modal.vue';
import LeadStageListModal from '@/components/modal/basic_settings/stage-list-modal.vue';
import CompetitorListModal from '@/components/modal/basic_settings/competitor-list-modal.vue';
import CompaniesListModal from '@/components/modal/basic_settings/companies-list-modal.vue';
import CountryListModal from '@/components/modal/basic_settings/country-list-modal.vue';
import DivisionListModal from '@/components/modal/basic_settings/division-list-modal.vue';
import DistrictListModal from '@/components/modal/basic_settings/district-list-modal.vue';
import ThanaListModal from '@/components/modal/basic_settings/thana-list-modal.vue';
import ZoneListModal from '@/components/modal/basic_settings/zone-list-modal.vue';
import RoleListModal from '@/components/modal/basic_settings/role-list-modal.vue';
import EmployeeListModal from '@/components/modal/basic_settings/employee-list-modal.vue';
import UnitListModal from '@/components/modal/basic_settings/unit-list-modal.vue';
import CategoryListModal from '@/components/modal/basic_settings/category-list-modal.vue';
import DocumentCategoryListModal from '@/components/modal/basic_settings/document-category-list-modal.vue';
import ProductListModal from '@/components/modal/basic_settings/product-list-modal.vue';
import DocumentListModal from '@/components/modal/manage-documents/document-list-modal.vue';
import LeadDeleteModal from '@/components/modal/lead-delete-modal.vue';
import ProspectDeleteModal from '@/components/modal/prospect-delete-modal.vue';
import ShowDocumentModal from '@/components/modal/manage-documents/show-doc-modal.vue';
import InfluencingRoleModal from '@/components/modal/basic_settings/influencing-role-modal.vue';
import ProspectImportModal from '@/components/modal/prospect-import-modal.vue';
import StackholderImportModal from '@/components/modal/stackholder-import-modal.vue';
import StackholderDeleteModal from '@/components/modal/stackholder-delete-modal.vue';
import BirthdayImportModal from '@/components/modal/birthday-import-modal.vue';
// *************** Basic settings modal Component ***************
import swal from 'sweetalert2';
window.Swal = swal;

// Define the handleModal function
const handleModal = (modalId, action) => {
  const modalEl = document.getElementById(modalId);
  if (!modalEl) return; // Ensure the modal element exists
  
  const modalInstance = Modal.getInstance(modalEl) || new Modal(modalEl);

  if (action === "show") {
    modalInstance.show();
  } else if (action === "hide") {
    modalInstance.hide();
  } else if (action === "toggle") {
    modalInstance.toggle();
  }
};

const app = createApp(App)
const emitter = mitt();
app.config.globalProperties.$emitter = emitter;
app.config.globalProperties.$handleModal = handleModal;

// *************** Components ***************
app.component('page-header', Breadcrumb)
app.component('dashboard-header', DashboardHeader)

// *************** Layout Component ***************
app.component('layouts-header', Header)
app.component('layouts-sidebar', Sidebar)
app.component('vertical-sidebar', VerticalSidebar)
app.component("files-sidebar", FilesSidebar);
app.component('side-settings', SideSettings)
app.component('index-loader', IndexLoader)

// *************** Page Component ***************
app.component('leads-tabs', Leads_Tabs )
app.component('leads-details-tabs', Leads_Details_Tabs )
app.component('individual-sidebar', Individual_Sidebar)
app.component('organization-sidebar', Organization_Sidebar )
app.component('leads-details-sidebar', Leads_details_Sidebar )
app.component('organization-update-sidebar', Organization_Update_Sidebar )
app.component('leads-details-section', Leads_Details_Section )
app.component('leads-concern-person-details-modal', Leads_Concern_person_Details_Modal )
app.component('file-preview-check', File_Preview_Check )
// *************** basic settings modal Component ***************
app.component('countires-modal', Countires_Modal )
app.component('profession-list-modal', ProfessionListModal )
app.component('department-list-modal', DepartmentsListModal )
app.component('source-list-modal', SourceListModal )
app.component('campaign-list-modal', CampaignListModal )
app.component('exhibitions-list-modal', ExhibitionListModal )
app.component('industry-list-modal', IndustryListModal )
app.component('stage-list-modal', LeadStageListModal )
app.component('competitor-list-modal', CompetitorListModal )
app.component('companies-list-modal', CompaniesListModal)
app.component('designations-list-modal', DesignationsListModal)
app.component('birthday-list-modal', BirthdayListModal)
app.component('country-list-modal', CountryListModal)
app.component('division-list-modal', DivisionListModal)
app.component('district-list-modal', DistrictListModal)
app.component('thana-list-modal', ThanaListModal)
app.component('zone-list-modal', ZoneListModal)
app.component('role-list-modal', RoleListModal)
app.component('employee-list-modal', EmployeeListModal)
app.component('unit-list-modal', UnitListModal)
app.component('category-list-modal', CategoryListModal)
app.component('document-category-list-modal', DocumentCategoryListModal)
app.component('document-list-modal', DocumentListModal);
app.component('document-show-modal', ShowDocumentModal);
app.component('product-list-modal', ProductListModal)
app.component('lead-delete-modal', LeadDeleteModal)
app.component('prospect-delete-modal', ProspectDeleteModal)
app.component('influencing-role-modal', InfluencingRoleModal)
app.component('prospect-import-modal', ProspectImportModal)
app.component('stackholder-import-modal', StackholderImportModal)
app.component('stackholder-delete-modal', StackholderDeleteModal)
app.component('birthday-import-modal', BirthdayImportModal)
// *************** basic settings modal Component ***************

app.component('date-picker', DatePicker)
app.component("star-rating", StarRating);
app.component("star-rating", StarRating);
app.component(VueFeather.name, VueFeather);

app.use(VueApexCharts)
  .use(VueEasyLightbox)
    .use(Antd) 
    .use(BootstrapVue3)
    .use(BToastPlugin)
    .use(ThemifyIcon)
    .use(SimpleLineIcons)
.use(VueToast, {
    position: "top-right",
  });
app.use(FlagIcon)
app.use(CKEditor);
app.use(store);
app.use(router).mount('#app');

